// extracted by mini-css-extract-plugin
module.exports = {"formWrap":"index_formWrap-3MRly","left":"index_left-lHwxe","right":"index_right-TWysm","btnWrap":"index_btnWrap-1FBOB"};